<template>
  <div class="bg" :height="fullHeight" :width="fullWidth">
    <spinner v-if="isLoading" />
    <b-container>
      <b-row>
        <b-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
          <b-card
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 shadow-sm p-2 mb-2 bg-white rounded"
          >
            <b-card-text class="w-100 text-center">
              <b-img :src="logo" fluid alt="Logo Evento" class="mb-3"></b-img>
              <h3>{{ titulo }}</h3>
              <p class="lead mb-3">{{ datos }}</p>
              <p>
                <b>{{ mensaje }}</b
                ><br />
                {{ $route.params }}
              </p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'
import errorSubnetMessages from '../../config/messages/errorSubnet.json'
import routerMessages from '../../config/messages/router.json'
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BImg,
  BAlert
} from 'bootstrap-vue'

export default {
  name: 'Mantenimiento',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BImg,
    BAlert,
    Spinner
  },
  data () {
    return {
      // Logo
      logo: null,
      isLoading: false,
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      curWidth: '',
      curHeight: '',
      idLink: null,
      mensajes: [],
      titulo: null,
      datos: null,
      mensaje: null
    }
  },
  beforeCreate: function () {
    localStorage.setItem('msgRouter', JSON.stringify(routerMessages))
    localStorage.setItem('msgErrorSubnet', JSON.stringify(errorSubnetMessages))
  },
  async created () {
    this.setImages()
    this.idLink = this.$route.params.id
    // obtener datos de apigrals desde axios
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.isLoading = false
    // Add mensajes from DB
    const mensajesLocales = JSON.parse(localStorage.getItem('msgErrorSubnet'))
    this.mensajes = mensajesLocales.filter(
      mens => mens.modulo === 'errorSubnet'
    )
    this.mensajes =
      this.mensajes.length > 0 ? this.mensajes : errorSubnetMessages
    this.titulo = this.mensajes[0].valor
    this.datos = this.mensajes[1].valor
    this.mensaje = this.mensajes[2].valor
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth - 2
      this.fullHeight = document.documentElement.clientHeight - 2
      this.curWidth = this.fullWidth + 'px'
      this.curHeight = this.fullHeight + 'px'
    },
    returnLobby () {
      this.$router.push({ path: '/' + localStorage.getItem('subnet') })
    },
    // Filter background and buttons
    setImages () {
      // Obtiene la lista de imagenes
      this.logo = require('@/assets/images/logo.png')
    }
  }
}
</script>

<style scoped>
.bg {
  background-color: #f6f7f8;
  height: 100vh;
  display: flex;
  align-items: center;
}
.fullheight {
  min-height: 100vh;
  overflow: hidden;
}
/*  Pone manita a todas las areas s*/
area {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorSubnet.vue